//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useContext, useEffect } from "react";

// custom pages
import { styles } from "./styles";

import Context from "context/context";

// material-ui
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import cronList from "apis/cronList/cronList";

const GlobalCss = withStyles({
  "@global": {
    ".MuiFormLabel-root": {
      color: "black",
    },
  },
})(() => null);

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

export default function CronList(props) {
  const { state, dispatch } = useContext(Context);
  const { getCron } = cronList();
  const classes = styles();
  const { t, i18n } = useTranslation()
  const [disableDropdown, setDisableDropdown] = useState(false);
  const [states, setstates] = useState({
    currentCron: "",
    currentTable: "",
    eLoading: false,
  });
  let reports = []
  let tableName =[]
  if(state?.userInfo?.loyalty_organization_name==="Henry Schein Dental"){
    reports = [
      {
        reportName: "CERTIFICATE_REDEEM_REJECTED",
        id: "CRON_1",
      },
      {
        reportName: "UNCONSENTED_MEMBER_ACCOUNT_DEACTIVATION",
        id: "CRON_2",
      },
      {
        reportName: "MARKETO",
        id: "CRON_3",
      },
      {
        reportName: "NEGATIVE_POINTS_UPDATE",
        id: "CRON_4",
      },
      {
        reportName: "USER_PASSWORD_MANAGEMENT",
        id: "CRON_5",
      },
      {
        reportName: "GENERATE_CONSENT_NONCONSENT_CSV",
        id: "CRON_6",
      },
      {
        reportName: "GENERATE_DAILY_LOYALTY_POINT_CSV",
        id: "CRON_7",
      },
      {
        reportName: "PROMO_EXPIRED_DEACTIVATE",
        id: "CRON_8",
      },
      {
        reportName: "SIGNATURE_FLAG_UPDATE",
        id: "CRON_9",
      },
      {
        reportName: "GENERATE_CONSENT_NONCONSENT_2_CSV",
        id: "CRON_10",
      },
      {
        reportName: "GENERATE_ACE_SOUTHERN_SOURCE_CSV",
        id: "CRON_11",
      },
      {
        reportName: "GENERATE_ACE_SOUTHERN_REVERSE_CSV",
        id: "CRON_12",
      },
      {
        reportName: "RollForward_Report",
        id: "CRON_13",
      },
      {
        reportName: "BILLTO_LOYALTY_DEACTIVATION_CRON",
        id: "CRON_15",
      },

      {
        reportName: "POINT_BALANCE_TRACKER_CRON",
        id: "CRON_16",
      },

      {
        reportName:"ANNUAL_STATMENTS_MAIL_SENDER_CRON",
        id: "CRON_17",
      },
      {
        reportName:"DORMANT_REMAINDER_MAIL_SENDER_CRON",
        id: "CRON_18",
      },
      {
        reportName:"ACCOUNTS_SYNC_WITH_GEP_US",
        id: "CRON_19",
      },
      {
        reportName:"LOYALTY_SHIPTO_UPDATION_CRON_US",
        id: "CRON_20",
      },
      {
        reportName:"AUTOMATED_BLOB_TOKEN_CRON_US",
        id: "CRON_21",
      },
      {
        reportName:"ACTIVATION_REMAINDER_MAIL_SENDER_CRON_US",
        id: "CRON_22",
      },
      {
        reportName:"HSD_Weekly_Cron_US",
        id: "CRON_23",
      },
      {
        reportName:"EARN_EMAIL_NOTIFICATION",
        id: "CRON_24",
      },

      {
        reportName:"STARTUP_AUTO_REDEMPTION",
        id: "CRON_25",
      },

      {
        reportName:"STARTUP_ENDDATE_UPDATION_CRON",
        id: "CRON_26",
      },

      {
        reportName:"STARTUP_BILLING_MAIL_SENDER_NOTIFICATION_CRON_US",
        id: "CRON_27",
      },
      {
        reportName:"TIER_END_DATE_TRACKER_CRON_TIME_US",
        id: "CRON_29",
      },
      {
        reportName:"Tier Validation Cron",
        id: "CRON_30",
      },
      {
        reportName:"Tier Redesign Email Sender Cron",
        id: "CRON_31",
      },
      {
        reportName:"Active Dormant Notification Mail Sender",
        id: "CRON_32",
      },
      {
        reportName:"Execute Thrive Unlocked Rule Engine",
        id: "CRON_33",
      },

      {
        reportName:"STARTUP_ENROLLMENT_BILLING_CRON_US",
        id: "CRON_34",
      },

      {
        reportName:"UNLOCK_ENDDATE_UPDATION_CRON_US",
        id: "CRON_35",
      },

      // {
      //   reportName:"UNLOCK_MANAGEMENT_SCREEN_RULE_ENGINE_US",
      //   id: "CRON_36",
      // },
       {
        reportName:"Unlock_KPI_SYNC",
        id: "CRON_37",
      },
      {
        reportName:"UNENROLLMENT_REMAINDER_EMAIL_NOTIFICATION_US",
        id: "CRON_38",
      },
       {
        reportName:"GROWTH_BONUS_EMAIL_CRON_US",
        id: "CRON_39",
      },
      {
        reportName:"Auto Unenrollment Cron",
        id: "CRON_40",
      },

      {
        reportName:"UNLOCKED_MILESTONE_MAIL_SENDER_CRON_US",
        id: "CRON_41",
      },

      {
        reportName:"SIGNATURE_MILESTONE_MAIL_SENDER_CRON_US",
        id: "CRON_42",
      },
      {
        reportName:"SIGNATURE_BENEFIT_STATEMENT_NOTIFICATION_US",
        id: "CRON_43",
      },
      {
        reportName:"THRIVE_BENEFIT_STATEMENT_NOTIFICATION_US",
        id: "CRON_44",
      },
    ];
    tableName = [
      {
        reportName: "Roll_Forward_point",
        id: "1",
      },
      {
        reportName: "Roll_Forward_point_Aug",
        id: "2",
      },

    ]
  }
  else{
    reports = [
      {
        reportName: "CERTIFICATE_REDEEM_REJECTED",
        id: "CRON_1",
      },
      {
        reportName: "UNCONSENTED_MEMBER_ACCOUNT_DEACTIVATION",
        id: "CRON_2",
      },
      {
        reportName: "MAILCHIMP",
        id: "CRON_3",
      },
      {
        reportName: "PROMO_EXPIRED_DEACTIVATE",
        id: "CRON_8",
      },
      {
     
        reportName: "ACTIVATION_REMAINDER",
        id: "CRON_14",
      },
      {
     
        reportName: "CA_RollForward_Report",
        id: "CRON_13",
      },

      {
     
        reportName: "BILLTO_LOYALTY_DEACTIVATION_CRON_CA",
        id: "CRON_15",
      },
      {
        reportName: "NEGATIVE_POINTS_UPDATE",
        id: "CRON_4",
      },

      {
        reportName: "POINT_BALANCE_TRACKER_CRON_CA",
        id: "CRON_16",
      },
      ,
      {
        reportName: "GENERATE_CONSENT_NONCONSENT_2_CSV",
        id: "CRON_10",
      },
      {
        reportName: "GENERATE_CONSENT_NONCONSENT_CSV",
        id: "CRON_6",
      },
      {
        reportName: "GENERATE_DAILY_LOYALTY_POINT_CSV",
        id: "CRON_7",
      },
      {
        reportName:"ACCOUNTS_SYNC_WITH_GEP_CA",
        id: "CRON_19",
      },

      {
        reportName:"LOYALTY_SHIPTO_UPDATION_CRON_CA",
        id: "CRON_20",
      },

      {
        reportName:"AUTOMATED_BLOB_TOKEN_CRON_CA",
        id: "CRON_21",
      },

      {
        reportName:"TIER_END_DATE_TRACKER_CRON_TIME_CA",
        id: "CRON_29",
      },

      // {
      //   reportName:"Tier_Bumpup_Email_Notification_CA",
      //   id: "CRON_38",
      // },
     
      
    ];
    tableName = [
      {
        reportName: "Roll_Forward_point",
        id: "1",
      },
      {
        reportName: "Roll_Forward_point2",
        id: "2",
      },

    ]
  }
  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Cron List"],
    });
  }, []);

  // CustomerStatus api func
  const handleExcuteCron = async () => {
    try {
      setDisableDropdown(true);
      let values = {};
      values = {
        cronName: states?.currentCron
      };
      if(states?.currentCron==='CRON_13'){
        values={...values,currentTable:states?.currentTable}
      }
      let res = await getCron(values);
      if (res && res?.status==200 && res.msg=="Selected cron executed successfully.") {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
        setDisableDropdown(false);
        setStates({
          response: true,
          eLoading: false,
        });
        toast.success(res?.msg, {
          toastId: "executed",
        });
        return true;
      }
      else {
        setStates({
          response: true,
          eLoading: false,
        });
        toast.error("Selected cron execution failed!", {
          toastId: "no-Data",
        });
        setDisableDropdown(false);
        return false;
      }
    } 
    catch (err) {
      console.log(err);
      setStates({
        response: true,
        eLoading: false,
      });
      setDisableDropdown(false);
    }
  };

  // report tab switch case
  return (
    <React.Fragment>
      <GlobalCss />
      <Grid container className={classes.root}>
        <Grid item xs={12} sm={12} lg={12} className={classes.topGrid}>
          <ThemeProvider theme={formLabelsTheme}>
            <TextField
              id={"report"}
              label={t("Select Cron")}
              select
              required
              type={"text"}
              className={classes.input}
              value={states.currentCron}
              onChange={(e) => {
                setStates({
                  currentCron: e.target.value,
                });
                if( e.target.value ==='CRON_13'){
                  setStates({
                    currentTable:"1" ,
                  });
                
                }
              }}
              disabled={disableDropdown}
            >
              {reports.map((r, i) => (
                <MenuItem value={r.id} key={t(r.reportName)}>
                  {t(r.reportName)}
                </MenuItem>
              ))}
            </TextField>
          </ThemeProvider>
        </Grid>
        {states?.currentCron&&states?.currentCron==='CRON_13' &&
        <Grid item xs={12} sm={12} lg={12} className={classes.topGrid}>
          <ThemeProvider theme={formLabelsTheme}>
            <TextField
              id={"tableName"}
              label={t("Select Table name")}
              select
              required
              type={"text"}
              className={classes.input}
              value={states.currentTable}
              onChange={(e) => {
                setStates({
                  currentTable: e.target.value,
                });
                
              }}
              disabled={disableDropdown}
            >
              {tableName.map((r, i) => (
                <MenuItem value={r.id} key={t(r.reportName)}>
                  {t(r.reportName)}
                </MenuItem>
              ))}
            </TextField>
          </ThemeProvider>
        </Grid>
}
      </Grid>
      <div>  
        <Button
          className={classes.exportBtn}
          onClick={async () => {
            if (!states?.currentCron) {
              toast.error(
                "Please select the Cron ",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
            setStates({
              response: false,
              eLoading: true
            });
            let res = await handleExcuteCron();
            if (res) {
              console.log("csv read", res)
            }
          }}
          disabled={states.eLoading}
        >
          Execute
        </Button>
      </div>
    </React.Fragment>
  );
}